import { table } from './_table';
export const webhook = {
  namespaced: true,
  modules: {
    table
  }
};
